import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ProductCarouselTypeState from "@tCooneyBrothers/Store/Data/ProductCarouselType/ProductCarouselTypeState";

export interface ProductCarouselTypeParameter {
    type: keyof ProductCarouselTypeState | "reset";
    value: boolean;
}

type HandlerType = Handler<ProductCarouselTypeParameter>;

export const ProductCarouselTypeAccessory: HandlerType = props => {
    if (props.parameter.type !== "accessory") {
        return;
    }
    (props as any).dispatch({
        type: "Custom/ProductCarousel/SetAccessories",
        result: props.parameter.value,
    });
};

export const ProductCarouselTypeSimilarItem: HandlerType = props => {
    if (props.parameter.type !== "similarItems") {
        return;
    }
    (props as any).dispatch({
        type: "Custom/ProductCarousel/SetSimilarItems",
        result: props.parameter.value,
    });
};

export const ProductCarouselTypeRelatedItems: HandlerType = props => {
    if (props.parameter.type !== "relatedItems") {
        return;
    }
    (props as any).dispatch({
        type: "Custom/ProductCarousel/SetRelatedItems",
        result: props.parameter.value,
    });
};
export const ProductCarouselTypeSpareParts: HandlerType = props => {
    if (props.parameter.type !== "spareParts") {
        return;
    }
    (props as any).dispatch({
        type: "Custom/ProductCarousel/SetSpareParts",
        result: props.parameter.value,
    });
};
export const ProductCarouselReset: HandlerType = props => {
    if (props.parameter.type !== "reset") {
        return;
    }
    (props as any).dispatch({
        type: "Custom/ProductCarousel/Reset",
        result: props.parameter.value,
    });
};

export const chain = [
    ProductCarouselTypeAccessory,
    ProductCarouselTypeSimilarItem,
    ProductCarouselTypeRelatedItems,
    ProductCarouselTypeSpareParts,
    ProductCarouselReset,
];

const productCarouselType = createHandlerChainRunner(chain, "CustomProductCarouselType");
export default productCarouselType;
